import { Step } from "./Step";
import { StepTypes } from "../../enum/StepTypes";
import { MultiLanguage } from "../../MultiLanguage";

export class LegalStep extends Step {
    private _dataProtectionText: MultiLanguage;
    private _legalConsentText: MultiLanguage;

    constructor(step: any) {
        super(step);
        this._name = StepTypes.translations[step.type].name;
        this._dataProtectionText = new MultiLanguage(step.dataProtectionText);
        this._legalConsentText = new MultiLanguage(step.legalConsentText);
    }

    public get dataProtectionText(): MultiLanguage {
        return this._dataProtectionText;
    }
    public get legalConsentText(): MultiLanguage {
        return this._legalConsentText;
    }
}